import { Outlet, ScrollRestoration } from 'react-router-dom'
import GlobalStyles from '@styles/global-styles'
import Toast from '@features/toast/toast'
import CrispChat from '@features/crisp-chat/components/crisp-chat'
import { TestSurvey } from '@features/surveys/survey'
import { useState, useEffect } from 'react'
import { useLazyModulesGetUserModulesQuery } from '@app/services/auto-generated/modules'

const RootLayout: React.FC = () => {
  const [showSurvey, setShowSurvey] = useState(false)
  const [getModules] = useLazyModulesGetUserModulesQuery()

  useEffect(() => {
    const checkSurveyStatus = async () => {
      try {
        const response = await getModules().unwrap()
        if (!response.submitted.includes('SurveyDisplayModule')) {
          setShowSurvey(true)
        }
      } catch (error) {
        console.error('Failed to check survey status:', error)
      }
    }

    checkSurveyStatus()
  }, [getModules])

  return (
    <>
      <ScrollRestoration />
      <GlobalStyles />
      <Toast />
      {showSurvey && <TestSurvey />}
      <Outlet />
      <CrispChat />
    </>
  )
}

export default RootLayout
